import React from "react";
import moment from "moment";
import { useTranslation } from "src/_common/hooks/useTranslation";

interface InterviewDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  interview: any;
  candidate: any;
  onApprove: () => void;
  onDecline: () => void;
}

const InterviewDetailsModal: React.FC<InterviewDetailsModalProps> = ({
  isOpen,
  onClose,
  interview,
  candidate,
  onApprove,
  onDecline,
}) => {
  const { t } = useTranslation("job-details");

  if (!isOpen) return null;

  const meetingDateTime = interview?.interview_schedule ? moment.utc(interview.interview_schedule).local() : null;
  const interviewerName = interview?.member?.name
    ? interview.member.name
    : interview?.company?.recruiter_name
      ? interview.company.recruiter_name
      : interview?.company?.name
        ? interview.company.name
        : "N/A";

  return (
    <div
      className="modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1050,
      }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: "500px", width: "90%" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {t("jobDetails.interview.interviewDetailsModal.title") || "Interview Details"}
            </h5>
            <button
              type="button"
              className="close"
              onClick={onClose}
              style={{
                background: "none",
                border: "none",
                fontSize: "1.5rem",
                cursor: "pointer",
              }}
            >
              ×
            </button>
          </div>
          <div className="modal-body" style={{ background: "#fff" }}>
            {/* Candidate */}
            <div style={{ marginBottom: "15px" }}>
              <label style={{ fontWeight: "bold", marginRight: "10px" }}>
                {t("jobDetails.interview.interviewDetailsModal.candidate") || "Candidate"}
              </label>
              <p style={{ margin: 0, display: "inline" }}>{candidate?.name || "N/A"}</p>
            </div>

            {/* Interviewer */}
            <div style={{ marginBottom: "15px" }}>
              <label style={{ fontWeight: "bold", marginRight: "10px" }}>
                {t("jobDetails.interview.interviewDetailsModal.interviewer") || "Interviewer"}
              </label>
              <p style={{ margin: 0, display: "inline" }}>{interviewerName}</p>
            </div>

            {/* Date */}
            <div style={{ marginBottom: "15px" }}>
              <label style={{ fontWeight: "bold", marginRight: "10px" }}>
                {t("jobDetails.interview.interviewDetailsModal.date") || "Date"}
              </label>
              <p style={{ margin: 0, display: "inline" }}>
                {meetingDateTime?.isValid()
                  ? meetingDateTime.format("MMMM D, YYYY")
                  : t("jobDetails.interview.interviewDetailsModal.invalidDate") || "Invalid Date"}
              </p>
            </div>

            {/* Time */}
            {interview?.interview_schedule && (
              <div style={{ marginBottom: "15px" }}>
                <label style={{ fontWeight: "bold", marginRight: "10px" }}>
                  {t("jobDetails.interview.interviewDetailsModal.time") || "Time"}
                </label>
                <p style={{ margin: 0, display: "inline" }}>
                  {meetingDateTime?.isValid()
                    ? meetingDateTime.format("h:mm A")
                    : t("jobDetails.interview.interviewDetailsModal.invalidTime") || "Invalid Time"}
                </p>
              </div>
            )}

            {/* Action Buttons */}
            <div style={{ marginTop: "20px" }}>
              <button
                type="button"
                className="btn btn-success"
                onClick={onApprove}
                style={{ marginRight: "10px" }}
              >
                <i className="fa fa-check" style={{ marginRight: "5px" }}></i>
                {t("jobDetails.interview.interviewDetailsModal.approve") || "Approve"}
              </button>
              <button type="button" className="btn btn-danger" onClick={onDecline}>
                <i className="fa fa-times" style={{ marginRight: "5px" }}></i>
                {t("jobDetails.interview.interviewDetailsModal.decline") || "Decline"}
              </button>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn-cancel" onClick={onClose}>
              {t("jobDetails.interview.interviewDetailsModal.close") || "Close"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewDetailsModal;
